module.exports = __webpack_public_path__ + "static/media/avatar_20.fee01517.svg";